import * as chrono from 'chrono-node';
import Occasion from './Occasion';

type Refiner = chrono.Refiner['refine'];

const customDateParser = chrono.casual.clone();

const noonRefiner: Refiner = (_, results) => {
  results.forEach((result) => {
    if (/\bnoon\b/i.test(result.text)) {
      result.start.assign('hour', 12);
      result.start.assign('minute', 0);
    }
  });
  return results;
};

const midnightRefiner: Refiner = (_, results) => {
  results.forEach((result) => {
    if (/\bmidnight\b/i.test(result.text)) {
      result.start.assign('hour', 0);
      result.start.assign('minute', 0);
    }
  });
  return results;
};

const afternoonRefiner: Refiner = (_, results) => {
  results.forEach((result) => {
    if (/\bafternoon(?! at)\b/i.test(result.text)) {
      result.start.assign('hour', 14);
      result.start.assign('minute', 0);
    }
  });
  return results;
};

const nightRefiner: Refiner = (_, results) => {
  results.forEach((result) => {
    if (/\b(night(?! at)|evening(?! at))\b/i.test(result.text)) {
      result.start.assign('hour', 18);
      result.start.assign('minute', 0);
    }
  });
  return results;
};

const dayMatcher =
  /\bmon(day)?|tue(sday)?|wed(nesday)?|thu(rsday)?|fri(day)?|sat(urday)?|sun(day)?\b/i;

const pastWeekdayRefiner: Refiner = (_, results) => {
  results.forEach((result) => {
    if (dayMatcher.test(result.text) && !/\blast\b/i.test(result.text)) {
      const matchedOccasion = new Occasion(result.date());
      if (matchedOccasion.isPast || matchedOccasion.isToday) {
        const adjustedDate = matchedOccasion.addDays(7);
        result.start.assign('day', adjustedDate.getDate());
        // Date months are zero indexed, ParsedResult months are not
        result.start.assign('month', adjustedDate.getMonth() + 1);
        result.start.assign('year', adjustedDate.getFullYear());
      }
    }
  });
  return results;
};

[noonRefiner, midnightRefiner, afternoonRefiner, nightRefiner, pastWeekdayRefiner].forEach(
  (refine) => customDateParser.refiners.push({ refine }),
);

export default customDateParser;
